import React from 'react';
import { translate } from '../../Services/translation';

const CustomVariantSummary = ({ configuratorModel, currencySymbol }) => {

  const formatPrice = (price) => {
    return price.toLocaleString()
  }

  return (
    <>
      <span className="[ custom-variant__summary-header ] [ text-medium bold lh-2 ]">
        {translate('custom-variant.summary')}
      </span>
      <div className="custom-variant__summary">
        {configuratorModel.priceResult?.priceDetails.map((priceRow, index) => (
          <div
            key={priceRow.description + index}
            className={`custom-variant__summary-row ${
              priceRow.isDiscountRow && 'color-error-700'
            }`}
          >
            <span>{priceRow.description}</span>
            <span>
              {formatPrice(priceRow.price)} {currencySymbol}
            </span>
          </div>
        ))}

        <div className="custom-variant__summary-total">
          <span>{translate('custom-variant.total')}</span>
          <span>
            {configuratorModel.priceResult?.priceTotalCampaign
              ? formatPrice(configuratorModel.priceResult?.priceTotalCampaign)
              : formatPrice(configuratorModel.priceResult?.priceTotal)}{' '}
            {currencySymbol}
          </span>
        </div>
      </div>
    </>
  );
};

export default CustomVariantSummary;
